<template>
    <div>
        <nav class="breadcrumb is-small is-left" aria-label="breadcrumbs">
            <ul>
                <li v-for="(data, index) in trail" :key="index" :class="{'is-active': !data.showLink}">
                    <router-link :to="data.showLink ? data.link : '#'" :aria-current="data.showLink ? '': 'page'">{{$t(data.name)}}</router-link>
                </li>
            </ul>
            
        </nav>
    </div>
</template>

<script>

export default {
    props: ['trail']
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Breadcrumbs/Index.vue